module.exports = __webpack_public_path__ + "img/guide-1.8c921bcc.png";